import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Home, Users, Settings } from 'lucide-react';

const navItems = [
  { to: '/', icon: Home, labelKey: 'home' as const, end: true },
  { to: '/friends', icon: Users, labelKey: 'friends' as const, end: false },
  { to: '/settings', icon: Settings, labelKey: 'settings' as const, end: false },
] as const;

export default function BottomNav() {
  const { t } = useTranslation();

  return (
    <nav
      className="fixed bottom-0 inset-x-0 z-40 md:hidden bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 pb-[env(safe-area-inset-bottom,0px)]"
      aria-label={t('mainNavigation')}
    >
      <div className="flex items-center justify-around">
        {navItems.map(({ to, icon: Icon, labelKey, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center min-h-[48px] flex-1 py-1.5 transition ${
                isActive
                  ? 'text-green-500 dark:text-green-400'
                  : 'text-gray-400 dark:text-gray-500'
              }`
            }
          >
            <Icon className="w-5 h-5" />
            <span className="text-xs mt-0.5">{t(labelKey)}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
